import { AppBar, Container, Toolbar } from "@material-ui/core";
import ReactGA from "react-ga4";

import styles from "./Header.module.scss";
import { Logo } from "./Logo";
import { Navigation } from "./Navigation";

//JIRA LPPLWEBMOB-677
if (window.location.hostname === "my.ayvens.pl") {
  //PROD
  ReactGA.initialize("G-T6RP7VCD9V");
} else {
  //UAT + DEV + PGS
  ReactGA.initialize("G-HNZ4HB69G6");
}

export const Header = (): JSX.Element => (
  <AppBar className={styles.header}>
    <Toolbar disableGutters className={styles.toolbar}>
      <Container className={styles.container}>
        <Logo />
        <Navigation />
      </Container>
    </Toolbar>
  </AppBar>
);
